<template>
    <div class='window white'>
        <p class='info-message gentle-message'>
            Page not found. Redirecting to <router-link to='/'>curve.finance</router-link>
        </p>
        <p>
            <img :src="publicPath + 'llama.jpg'">
        </p>
    </div>
</template>

<script>
export default {
    computed: {
        publicPath() {
            return process.env.BASE_URL
        },
    },

    mounted() {
        setTimeout(() => this.$router.push('/'), 2300)
    },
}
</script>

<style scoped>
img {
    width: 100%;
    margin-top: 1em;
}
</style>
